import { Component } from '@angular/core';

@Component({
  templateUrl:'./rooms.component.html'
})
export class RoomsComponent {

}
